// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createDealerTransferHistory} from '../../shared/repositories';

export const createDealerTransferHistoryReport = postArgs =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await createDealerTransferHistory(postArgs);

            const hasNoResult = data.length < 1;

            dispatch({
                data,
                type: actions.CREATE_DEALER_TRANSFER_HISTORY_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/dealer-transfer-history/action-creators/report.js